const _isEmpty = [null, void 0, '']
const _regIsEmail = /^[A-Za-z0-9]{1}[A-Za-z0-9_.+-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/
const _regIsKana = /^[ァ-ヴa-zA-Zａ-ｚＡ-Ｚ0-9０-９\-ー‐‑–—―−－&'.,＆’，．・\s]+$/
const _regIsTel = /^[0-9\-+()]+$/
const _regIsZipcode = /^[0-9-]+$/

export default {
  methods: {
    isEmpty: val => _isEmpty.indexOf(val) !== -1,
    isNumber: val => typeof val === 'number',
    isEmail: val => _regIsEmail.test(val),
    isKana: val => _regIsKana.test(val),
    isTel: val => _regIsTel.test(val),
    isZipcode: val => _regIsZipcode.test(val),
  },
}
